// extracted by mini-css-extract-plugin
module.exports = {"dots":"Dots_dots__SqOqB"};